export const BREADCRUMBS_ID = 'breadcrumbs';
export const DEFAULT_BREADCRUMBS_HEIGHT = 64;
